export enum IconTypeEnum {
  NZ = 'NZ',
  WAYTR = 'WAYTR',
}
